import React from 'react';
import { Box, Typography } from '@mui/material';

interface SideDishEmptyProps {
}

const SideDishEmpty: React.FC<SideDishEmptyProps> = ({ }) => {
    return (
        <Box
            // position={"absolute"}
            display={"flex"}
            flexDirection={"column"}
            justifyContent={"center"}
            alignItems={"center"}
            width={"100%"}
            left={0}
            right={0}
            marginLeft={"auto"}
            marginRight={"auto"}
            height={"100%"}>
            <img
                src={require(`../../../../../assets/offer/food-category/ketchup.png`)}
                height={68} />
            <Typography mt={2} fontWeight={600}>Za ovaj proizvod ne postoje prilozi</Typography>
        </Box>
    )
}

export default SideDishEmpty;